import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import CountryForm from './CountryForm';

const CountryItem = ({ alpha2, alpha3, name_ru, name_en }) => {
    const { i18n } = useTranslation();
    const [ isEditor, setIsEditor ] = useState(false);
    const [ innerAlpha2, setInnerAlpha2 ] = useState(alpha2);
    const [ innerAlpha3, setInnerAlpha3 ] = useState(alpha3);
    const [ innerNameRu, setInnerNameRu ] = useState(name_ru);
    const [ innerNameEn, setInnerNameEn ] = useState(name_en);

    if (isEditor) return (<li>
        <CountryForm
            alpha2={innerAlpha2}
            alpha3={innerAlpha3}
            name_ru={innerNameRu}
            name_en={innerNameEn}
            onChange={(a2, a3, ru, en) => {
                setInnerAlpha2(a2);
                setInnerAlpha3(a3);
                setInnerNameRu(ru);
                setInnerNameEn(en);
                setIsEditor(false);
            }}
        />
    </li>);

    return (
        <li onClick={() => setIsEditor(true)}>
            <span className='InlineButtonBlank'>{innerAlpha2}</span>
            <span className='InlineButtonBlank'>{innerAlpha3}</span>
            <span>{i18n.language === 'en' ? innerNameEn : innerNameRu}</span>
        </li>
    );
};

CountryItem.propTypes = {
    alpha2: PropTypes.string.isRequired, // код альфа2
    alpha3: PropTypes.string.isRequired, // код альфа3
    name_ru: PropTypes.string.isRequired, // название по-русски
    name_en: PropTypes.string.isRequired, // название по-английски
};

export default CountryItem;
